<template lang="html">
   <div class="mobile">
      <div class="row">
         <div class="col-6 col-md-4">
            <div class="country-field clearfix" @click="showModal = true">
               <div class="flag-box">
                  <img :src="selectedCountry.flag" alt="" class="flag">
               </div>
               <div class="name">{{selectedCountry.alpha2Code}}</div>
               <div class="code" v-if="selectedCountry.callingCodes">(+{{selectedCountry.callingCodes[0]}})</div>
            </div>
         </div>
         <div class="col-6 col-md-8">
            <InputText
               name="mobile"
               type="text"
               :model="mobile"
               v-model="mobile"
               action="select"
               :placeholder="placeholder"
               @input="updateSelf()"
            />
         </div>
      </div>

      <Modal 
         type="simple"
         :show="showModal" 
         @close="showModal=false"
      >
         <template slot="content">
            <div class="modal-content">
               <div class="modal-title">
                  <div class="title">Select Country</div>
                  <button class="close" @click="showModal = false" aria-label="Close">
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <InputText 
                     class="search" 
                     name="search"
                     type="text"
                     :model="search"
                     v-model="search"
                     action="search"
                     :prepend="prependIcon"
                     placeholder="Search Country"
                     @input="searchCountries()"
                  />
                     <div class="countries">
                        <scrollbar>
                           <div 
                              class="country clearfix" 
                              v-for="country in countries" 
                              v-if="country.callingCodes[0] !== ''" 
                              :key="country.alpha2Code"
                              @click="selectCountry(country)"
                           >
                              <div class="flag-box">
                                 <img class="flag" :src="country.flag" alt="">
                              </div>
                              <div class="name">{{country.name}}</div>
                              <div class="code">+{{country.callingCodes[0]}}</div>
                           </div>
                        </scrollbar>
                     </div>
               </div>
            </div>
         </template>
      </Modal>
   </div>
</template>

<script>
import VueScrollbar from 'vue-scrollbar-simple'

export default {
   components:{
      Modal: () => import("./modal"),
      Select: () => import("./select/select"),
      Option: () => import("./select/option"),
      InputText: () => import("./text"),
      scrollbar: VueScrollbar,
   },
   props: {
      value: {
         default: function(){
            return {
               mobile: '',
               code: {
                  callingCode: '',
                  countryCode: ''
               }
            }
         }
      },
      placeholder: {
         default: undefined
      },
   },
   watch: {
      value($new,$old) {
         if(this.value.mobile !== this.mobile){
            this.mobile = this.value.mobile
         }
         if(this.value.code.callingCode !== this.code.callingCode && this.value.code.countryCode !== this.code.countryCode){
            this.code = this.value.code
            this.filterSelectedCountry()
         }
      }
   },
   data () {
      return {
         address: '',
         countries: [],
         allCountries: [],
         mobile: '',
         search: '',
         showModal: false,
         selectedCountry: {},
         code: {
            callingCode: '',
            countryCode: ''
         },
         prependIcon: `<i class="fa fa-search"></i>`
      }
   },
   methods: {
      updateSelf() {
         this.$emit("input", {
            mobile: this.mobile,
            code: this.code
         });
      },
      async fetchCountries(){
         let countries = await $session.get('countries')

         if(countries){
            this.countries = countries
            this.allCountries = countries

            // Get selected country if country value is not found
            if(this.value.code.countryCode === ''){
               await this.getSelectedCountry()
            }else{
               await this.filterSelectedCountry()
            }

            this.code = {
               callingCode: this.selectedCountry.callingCodes[0],
               countryCode: this.selectedCountry.alpha2Code,
            }
         }

         if(this.value.mobile){
            this.mobile = this.value.mobile
         }
      },
      async filterSelectedCountry(){
         try {
            let country = this.allCountries.filter((c) => {
               return c.alpha2Code === this.value.code.countryCode
            })[0]

            if(country){
               this.selectedCountry = country
            }else{
               await this.getSelectedCountry()
            }
         } catch (err) {throw err}
      },
      async getSelectedCountry(){
         try {
            let country = await $session.get('country')

            if(country){
               this.selectedCountry = country
            }else{
               this.selectedCountry = this.countries[0]
            }
         } catch (err) {throw err}
      },
      selectCountry(country){
         this.selectedCountry = country

         this.code = {
            callingCode: country.callingCodes[0],
            countryCode: country.alpha2Code
         }

         this.showModal = false
      },
      searchCountries(){
         this.countries = this.allCountries.filter((country) => {
            return country.name.toLowerCase().includes(this.search.toLowerCase())
         })
      }
   },
   async mounted(){
      await this.fetchCountries()
   }
}
</script>